export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const filePath = node.data.path || ''
  const fileName = node.data.filename || ''
  const mimeType = node.data.mimeType || ''

  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  let html = ''

  if (! filePath && ! fileName) {
    $('#hover-node-card .card-body').html('')
  } else {
    const videoSource = 'https://192.168.10.60/xerochat/' + filePath + fileName

    html += '<div class="hover-media-wrapper">'
    html += '<video class="hover-media-video" width="100%" height="auto" controls>'
    html += `<source src="${videoSource}" type="${mimeType}">`
    html += 'Your browser does not support the video tag.'
    html += '</video>'
    html += '</div>'
    
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }    

    $('#hover-node-card .card-body').html(html)
  }  
}